import { render, staticRenderFns } from "./situationorg.vue?vue&type=template&id=063cde50&scoped=true&"
import script from "./situationorg.vue?vue&type=script&lang=js&"
export * from "./situationorg.vue?vue&type=script&lang=js&"
import style0 from "./situationorg.vue?vue&type=style&index=0&id=063cde50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063cde50",
  null
  
)

export default component.exports